import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TextMaskModule } from 'angular2-text-mask';
import { Router, ActivatedRoute } from "@angular/router";
import { Validators, FormBuilder, FormGroup } from "@angular/forms"

// import { GeralService } from '../../services/geral.service';
import { ClienteService } from '../../services/cliente.service';
import { AlertService } from '../../providers/alert.service';

@Component({
	selector: 'app-cadastro-cliente',
	templateUrl: './cadastro-cliente.component.html',
	styleUrls: ['./cadastro-cliente.component.scss', '../../assets/less/all.less']
})
export class CadastroClienteComponent implements OnInit {
	cliente = {
        descricao: null,
        cod_cliente: null,
        status: null,
        telefone: null,
        cep: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null,
        email: null,
        site: null,
        nome_contato: null,
        id: null
	};
	
    ufs;
    is_edicao = false;
    id: number;
    private sub: any;
    public cliente_form: FormGroup
    public loading = false;

	constructor( 
		public cliente_service: ClienteService,
        // public geral_service: GeralService,
        private router: Router,
        public formBuilder: FormBuilder,
        public activated_router: ActivatedRoute,
        private ref: ChangeDetectorRef,
		public alerts: AlertService
	) { 
		this.cliente_form = this.formBuilder.group({
			descricao: ['',Validators.required] ,
			cod_cliente: ['',Validators.required],
			status: ['',Validators.required],
			// telefone: ['', Validators.nullValidator],
			// cep: ['',Validators.required],
			// logradouro: ['',Validators.required],
			// numero: ['',Validators.required],
			// complemento: ['',Validators.required],
			// bairro: ['',Validators.required],
			// cidade: ['',Validators.required],
			// uf: ['',Validators.required],
			// email: ['', Validators.nullValidator],
			// site: ['', Validators.nullValidator],
			// nome_contato: ['', Validators.nullValidator]
		})
	}

	ngOnInit() {
		this.sub = this.activated_router.params.subscribe(params => {
            this.id = params['id'];
            if (this.id != 0) {
                this.loading = true;
                console.log("id no cadastro", this.id)
                this.cliente_service.getClientesByID(this.id)
                .then(res => {
                    console.log('res', res)
                    this.is_edicao = true;
                    let status = res['status']
                    this.cliente.id = res['_id']
                    this.cliente.cod_cliente = res['cod_cliente']
                    this.cliente.descricao = res['descricao']
                    this.cliente.status = String(status)
                    this.loading = false;
                })
                .catch(error =>{
                    this.loading = false;
                })
                this.ref.detectChanges();
            }

        });

    }
    
    

	getUfLista() {
        // this.geral_service.getUfLista().then(res => {
        //     if (res['success']) {
        //         this.ufs = res['data'];
        //     }
        // })
    }

    salvar() {
        console.log('oi salvar' + this.is_edicao)
        this.loading = true;
        if (this.is_edicao) {
            this.cliente_service.putCliente(this.cliente).then(res => {
                if (res['success']) {
                    this.loading = false;
                    this.alerts.openAlert('Tudo certo!', 'Atualizado com sucesso');
                } else {
                    this.loading = false;
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                }
            })
            .catch(error =>{
                this.loading = false;
            })
        } else {
            this.cliente_service.salvarCliente(this.cliente).then(res => {
                if (res['cod_cliente']) {
                    this.loading = false;
                    this.alerts.openAlert('Tudo certo!', 'Salvo com sucesso');
                } else {
                    this.loading = false;
                    this.alerts.openAlert("Ops,", 'Ocorreu um erro, tente novamente mais tarde')
                }
            })
            .catch(error =>{
                this.loading = false;
            })
        }
    }

    openClientes() {
        this.router.navigate(['clientes'])
    }

}
